var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(-1061 -1853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    transform: "translate(1061 1853)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(42.155 83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(1021.846 1786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M294.1,397.521h26.528v-8.1a11.547,11.547,0,0,0-8.687-11.188l-12.066-3.085H288.323l-12.067,3.085a11.548,11.548,0,0,0-8.687,11.188v8.1Z",
    transform: "translate(-267.569 -336.62)",
    fill: "#ffb0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M354.5,384.044a8.9,8.9,0,0,0,8.858-8.106l-3.083-.788H348.73l-3.084.788A8.9,8.9,0,0,0,354.5,384.044Z",
    transform: "translate(-327.976 -336.62)",
    fill: "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M359.273,343.431v7.178a5.774,5.774,0,0,0,11.548,0v-7.177Z",
    transform: "translate(-338.519 -312.081)",
    fill: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M359.273,348.29a14.187,14.187,0,0,0,11.547,0v-4.859H359.273Z",
    transform: "translate(-338.519 -312.081)",
    fill: "#fcb98b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M355.725,259v10.994a12.016,12.016,0,1,1-24.031,0V259Z",
    transform: "translate(-317.181 -246.758)",
    fill: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M343.708,204.908a12.016,12.016,0,0,1,12.016,12.016v2.942H350l-1.358-2.037-1.358,2.037h-7.145l-1.358-2.037-1.358,2.037h-5.727v-2.942A12.016,12.016,0,0,1,343.708,204.908Z",
    transform: "translate(-317.181 -204.908)",
    fill: "#6e83b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M437.876,271.034h.858A2.263,2.263,0,0,1,441,273.3v3.432a2.263,2.263,0,0,1-2.263,2.263h-.858Z",
    transform: "translate(-399.332 -256.068)",
    fill: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M0,0H.858A2.263,2.263,0,0,1,3.121,2.263V5.7A2.263,2.263,0,0,1,.858,7.959H0Z",
    transform: "translate(14.513 22.924) rotate(180)",
    fill: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M446.355,452.437h2.716v4.88h-2.716Z",
    transform: "translate(-405.892 -396.416)",
    fill: "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M311.213,452.437h2.716v4.88h-2.716Z",
    transform: "translate(-301.336 -396.416)",
    fill: "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M326.794,394.514V380.331l-3.571.913V401.53h27.865V381.244l-3.571-.913v14.183H326.794Z",
    transform: "translate(-310.628 -340.629)",
    fill: "#6e83b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(1074.742 1807.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482-2",
    "data-name": "Path 482",
    d: "M284.621,389.529h17.052v-5.206a7.422,7.422,0,0,0-5.584-7.191l-7.756-1.983H280.91l-7.756,1.983a7.423,7.423,0,0,0-5.584,7.191v5.206Z",
    transform: "translate(-267.569 -350.384)",
    fill: "#ffb0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483-2",
    "data-name": "Path 483",
    d: "M351.34,380.866a5.724,5.724,0,0,0,5.694-5.211l-1.982-.507h-7.423l-1.982.507A5.724,5.724,0,0,0,351.34,380.866Z",
    transform: "translate(-334.288 -350.384)",
    fill: "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484-2",
    "data-name": "Path 484",
    d: "M359.273,343.431v4.614a3.712,3.712,0,0,0,7.423,0v-4.613Z",
    transform: "translate(-345.933 -323.28)",
    fill: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485-2",
    "data-name": "Path 485",
    d: "M359.273,346.554a9.119,9.119,0,0,0,7.422,0v-3.123h-7.422Z",
    transform: "translate(-345.933 -323.28)",
    fill: "#fcb98b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486-2",
    "data-name": "Path 486",
    d: "M347.141,259v7.067a7.723,7.723,0,1,1-15.447,0V259Z",
    transform: "translate(-322.366 -251.131)",
    fill: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487-2",
    "data-name": "Path 487",
    d: "M339.416,204.908a7.723,7.723,0,0,1,7.723,7.723v1.891h-3.681l-.873-1.309-.873,1.309H337.12l-.873-1.309-.873,1.309h-3.681v-1.891A7.723,7.723,0,0,1,339.416,204.908Z",
    transform: "translate(-322.365 -204.908)",
    fill: "#6e83b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488-2",
    "data-name": "Path 488",
    d: "M437.876,271.034h.551a1.455,1.455,0,0,1,1.455,1.455v2.206a1.455,1.455,0,0,1-1.455,1.455h-.551Z",
    transform: "translate(-413.101 -261.414)",
    fill: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489-2",
    "data-name": "Path 489",
    d: "M0,0H.551A1.455,1.455,0,0,1,2.006,1.455V3.661A1.455,1.455,0,0,1,.551,5.116H0Z",
    transform: "translate(9.329 14.735) rotate(180)",
    fill: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490-2",
    "data-name": "Path 490",
    d: "M446.355,452.437H448.1v3.137h-1.746Z",
    transform: "translate(-420.347 -416.428)",
    fill: "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491-2",
    "data-name": "Path 491",
    d: "M311.213,452.437h1.746v3.137h-1.746Z",
    transform: "translate(-304.864 -416.428)",
    fill: "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492-2",
    "data-name": "Path 492",
    d: "M325.518,389.448v-9.117l-2.3.587v13.04h17.911v-13.04l-2.3-.587v9.117H325.518Z",
    transform: "translate(-315.127 -354.812)",
    fill: "#6e83b7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2);
export default __webpack_public_path__ + "static/media/a2.80cf1b57c24f87e45bb30c9e4f93b561.svg";
export { ForwardRef as ReactComponent };